/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowVirtualGameNightTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowVirtualGameNight,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Play Games Together Online!",
    "Virtual Game Night Awaits!",
    "Fun from the Comfort of Your Home!",
  ],
  title: "Virtual Game Night",
  description: "Organize a fun virtual game night.",
  longDescription:
    "Gather your friends for an exciting virtual game night! Choose a date, decide on games to play, and plan refreshments!",
  emoji: "💻",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Virtual Game Night",
          emoji: "💻",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the virtual game night?",
          emoji: "📅",
          completeAction: {
            question: "Decide on games to play?",
            description: "What games should we focus on during the night?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What games should we consider?",
                emoji: "🎲",
                completeAction: {
                  question: "Decide on snacks?",
                  description:
                    "What snacks should we prepare for the game night?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍕",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let the Games Begin Online!",
    outroDescription: "Your virtual game night plans are set! Enjoy the fun!",
  },
};
